// White screen after a deploy (Kate, 2026-10-29): sections are separate files with hashed names. A tab opened before a
// deploy asks for files the new version no longer has, the import fails and React rendered nothing. Now such a failure
// reloads the page once (the new version comes in); any other error shows a message with a Reload button.

const KEY = 'ops-portal:chunk-reload-at'

/** A failed load of a code file (old version after a deploy). */
export function isChunkError(e: unknown): boolean {
  const msg = e instanceof Error ? `${e.name} ${e.message}` : String(e ?? '')
  return /Failed to fetch dynamically imported module|Importing a module script failed|error loading dynamically imported module|ChunkLoadError|Loading chunk .* failed|Unable to preload CSS/i.test(msg)
}

/** Reload the page, at most once every 30 seconds (so a real outage can't cause a reload loop). True if it reloads. */
export function reloadOnce(): boolean {
  let last = 0
  try { last = Number(sessionStorage.getItem(KEY) || 0) } catch { /* storage blocked */ }
  if (Date.now() - last < 30_000) return false
  try { sessionStorage.setItem(KEY, String(Date.now())) } catch { /* storage blocked */ }
  window.location.reload()
  return true
}

/** React.lazy loader that reloads the page instead of failing when the file is gone after a deploy. */
export function retryImport<T>(load: () => Promise<T>): () => Promise<T> {
  return () =>
    load().catch((e) => {
      if (isChunkError(e) && reloadOnce()) return new Promise<T>(() => undefined) // page is reloading
      throw e
    })
}
